import { CURRENT_SDK_VERSION } from "../../config/build-variables.js";
import { FractalSDKAuthenticationError } from "../error/index.js";
import { maybeGetAccessToken } from "../token.js";
var CustomHeader;
(function (CustomHeader) {
    CustomHeader["FRACTAL_WEB_SDK_VERSION"] = "fractal-web-sdk-version";
})(CustomHeader || (CustomHeader = {}));
export function getDefaultSecureHeaders(headers = {}) {
    const accessToken = maybeGetAccessToken();
    if (!accessToken) {
        throw new FractalSDKAuthenticationError('Missing access token');
    }
    return {
        ...headers,
        authorization: `Bearer ${accessToken}`,
    };
}
export function getDefaultHeaders(headers = {}) {
    return {
        ...headers,
        [CustomHeader.FRACTAL_WEB_SDK_VERSION]: CURRENT_SDK_VERSION,
    };
}
//# sourceMappingURL=headers.js.map